import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const MedicalFeature = ({ data }) => {
    return (
        <div className="medical-feature-academic">
            <Link to={process.env.PUBLIC_URL + `/service-details/${data.id}`}>
                <div className="academic-header">
                    <span className="index">DEPT. {data.id < 10 ? `0${data.id}` : data.id}</span>
                    <h5 className="title">
                        {data.title} <span className="sub-title-en">[{data.subTitle}]</span>
                    </h5>
                </div>
                <div className="content">
                    <p>{data.excerpt}</p>
                </div>
            </Link>
        </div>
    );
};

MedicalFeature.propTypes = {
    data: PropTypes.object,
};

export default MedicalFeature;
